// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LYYZEzE,button.LYYZEzE{display:flex;justify-content:space-between;width:100%;padding:0 1.25em;font-size:16px}@media(min-width: 600px){.LYYZEzE,button.LYYZEzE{justify-content:center;padding:0;font-size:18px}}@media(min-width: 600px){.cDXLKQg{display:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `LYYZEzE`,
	"price": `cDXLKQg`
};
export default ___CSS_LOADER_EXPORT___;
